import { useMutation } from '@tanstack/react-query';
import { Discounts } from '@prisma/client';
import { createDiscount } from '../../services/discounts';
import { DiscountPayload, discountSchema } from '../../types/discounts';
import useUser from '../global/useUser';

interface Options {
  onSuccess?: (result: Discounts) => void | Promise<void>;
  onError?: (error: string) => void | Promise<void>;
}

function useCreateDiscount({ onSuccess, onError }: Options = {}) {
  const { user } = useUser();
  const businessId = user?.business?.id;

  return useMutation({
    mutationFn: async (payload: DiscountPayload) => {
      if (!businessId) return null;

      const validatedBody = await discountSchema.noUnknown().validate(
        { ...payload, code: payload.code || null },
        {
          stripUnknown: true,
        },
      );

      const result = await createDiscount(businessId, validatedBody);
      return result;
    },
    onSuccess: async result => {
      if (!result) return;
      await onSuccess?.(result);
    },
    onError: async error => {
      await onError?.(error?.message ?? 'Failed to create discount');
    },
  });
}

export default useCreateDiscount;
